/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'
let graphqlClient = null

export const state = {
  objects: {},
}

export const getters = {}

export const mutations = {
  SET_CLIENTS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
    // // console.log(state.objects)
  },
  SET_CLIENTREQUESTS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.requestobjects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.requestobjects, objects[key].id)
      }
    }
    state.requestobjects = {
      ...updatedObjects,
    }
    // // console.log(state.objects)
  },
  SET_CLIENTREQUEST(state, objects) {
    state.requestobjects = objects
  },
  SET_CLIENT(state, objects) {
    state.currentClient = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getClients({ commit }) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query {
            clients {
              id
              client_name
              address
              suburb
              postcode
              phone
              fax
              mobile
              contact_name
              title
              email
              abn
              drivers_licence
              created_at
              deleted_at
            }
          }
        `,
      })
      graphqlClient.cache.reset()
      commit('SET_CLIENTS', response.data.clients)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async getClientsWithSitesAndServices({ commit }) {
    // Only used in reports and we intentionally do not commit the data to the store.
    try {
      const response = await graphqlClient.query({
        query: gql`
          query {
            clients {
              id
              client_name
              address
              suburb
              postcode
              phone
              fax
              mobile
              contact_name
              title
              email
              abn
              drivers_licence
              created_at
              deleted_at
              sites {
                id
                address
                suburb
                state
                country
                email
                mobile
                phone
                contact_name
                trading_name
              }
              service_agreements{
                id
                services{
                  id
                  service_title
                  active
                  description
                  schedule_string
                  service_type_id{
                      name
                  }
                  waste_type{
                      name
                  }
                  service_bins{
                  id
                  price
                  weekly_maintenance_fee
                  extra_price
                  bin{
                      id
                      price
                      capacity
                      description
                    }
                  }
                  site{
                   trading_name
                   address
                   suburb
                   postcode
                   phone
                   mobile
                   email
                   contact_name
                 }
                }
              }
            }
          }
        `,
      })
      graphqlClient.cache.reset()
      return response.data.clients
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async getClientRequests({ commit }) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query {
              clientRequests {
                id
                address
                suburb
                postcode
                fax
                phone
                mobile
                contact_name
                title
                abn
                drivers_licence
                client_id
                created_at
                client {
                  id
                  client_name
                  email
                  address
                  suburb
                  phone
                  postcode
                  fax
                  mobile
                  contact_name
                  title
                  abn
                  drivers_licence
                }
              }
            }
          `,
        })
        .then(response => {
          graphqlClient.cache.reset()
          commit('SET_CLIENTREQUEST', response.data.clientRequests)

          return response.data.clientRequests
        })
    } catch (ex) {
      throw ex
    }
  },

  async getClientById({ commit }, { id } = {}) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query ClientById($cid: ID!) {
            clientById(id: $cid) {
              id
              client_name
              address
              suburb
              postcode
              phone
              fax
              mobile
              contact_name
              title
              email
              abn
              drivers_licence
              created_at
              deleted_at
            }
          }
        `,
        variables: { cid: id },
      })
      commit('SET_CLIENT', response.data.clientById)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createClient(
    { commit, dispatch },
    {
      client_name,
      address,
      suburb,
      state,
      country,
      postcode,
      phone,
      fax,
      mobile,
      contact_name,
      title,
      email,
      abn,
    } = {}
  ) {
    try {
      // let that = this
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation CreateClient(
              $clientName: String!
              $address: String!
              $State: String
              $Country: String
              $suburb: String!
              $postcode: Int!
              $phone: String!
              $fax: String
              $mobile: String
              $title: String
              $contactName: String!
              $email: String!
              $abn: String
            ) {
              createClient(
                client: {
                  client_name: $clientName
                  address: $address
                  state: $State
                  country: $Country
                  suburb: $suburb
                  postcode: $postcode
                  phone: $phone
                  fax: $fax
                  mobile: $mobile
                  title: $title
                  contact_name: $contactName
                  email: $email
                  abn: $abn
                }
              ) {
                id
                client_name
              }
            }
          `,
          variables: {
            clientName: client_name.trim(),
            address: address.trim(),
            State: state.trim(),
            Country: country.trim(),
            suburb: suburb.trim(),
            postcode: postcode,
            phone: phone,
            fax: fax,
            mobile: mobile,
            contactName: contact_name.trim(),
            title: title,
            email: email,
            abn: abn,
          },
        })
        .then(response => {
          // console.log('response.data.createClient', response)
          if(response.data.createClient){
            dispatch('getClients')
            return response.data.createClient.id
          }
        })
    } catch (ex) {
      let gqlerrors = ex.graphQLErrors['0'];
      if( gqlerrors.hasOwnProperty('message') ) {
        return { "error": gqlerrors.message };
      }
      throw ex
    }
  },
  async deleteClient({ commit }, { id } = {}) {
    try {
      // let that = this
      await graphqlClient.mutate({
        mutation: gql`
          mutation DeleteClient($did: Int!) {
            deleteClient(id: $did) {
              id
            }
          }
        `,
        variables: { did: parseInt(id) }
      }).then((response) =>{
        // console.log(response)
        // commit('SET_CLIENTS', response.data.deleteClient)
        return response;
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async updateClient(
    { commit },
    {
      id,
      client_name,
      address,
      suburb,
      postcode,
      phone,
      fax,
      mobile,
      contact_name,
      title,
      email,
      abn,
    } = {}
  ) {
    try {
      // let that = this
      const response = await graphqlClient.mutate({
        mutation: gql`
          mutation UpdateClient(
            $cid: Int!
            $clientName: String
            $address: String
            $suburb: String
            $postcode: Int
            $phone: String
            $fax: String
            $mobile: String
            $title: String
            $contactName: String
            $email: String
            $abn: String
          ) {
            updateClient(
              id: $cid
              client: {
                client_name: $clientName
                address: $address
                suburb: $suburb
                postcode: $postcode
                phone: $phone
                fax: $fax
                mobile: $mobile
                title: $title
                contact_name: $contactName
                email: $email
                abn: $abn
              }
            ) {
              id
            }
          }
        `,
        variables: {
          cid: id,
          clientName: client_name.trim(),
          address: address.trim(),
          suburb: suburb.trim(),
          postcode: postcode,
          phone: phone,
          fax: fax,
          mobile: mobile,
          contactName: contact_name.trim(),
          title: title,
          email: email,
          abn: abn,
        },
      })
      commit('SET_CLIENTS', response.data.updateClient)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async updateClientPassword({ commit }, { id, password } = {}) {
    try {
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation UpdateClient($cid: Int!, $password: String) {
              updateClient(id: $cid, client: { password: $password }) {
                id
              }
            }
          `,
          variables: { cid: id, password: password },
        })
        .then(response => {
          // console.log(response)
          commit('SET_CLIENTS', response.data.updateClient)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createClientRequest(
    { commit, dispatch },
    {
      address,
      suburb,
      state,
      country,
      postcode,
      phone,
      fax,
      mobile,
      contact_name,
      title,
      abn,
    } = {}
  ) {
    try {
      // let that = this
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation CreateClientRequest(
              $address: String!
              $State: String
              $Country: String
              $suburb: String!
              $postcode: Int!
              $phone: String!
              $fax: String
              $mobile: String
              $title: String
              $contactName: String!
              $abn: String
            ) {
              createClientRequest(
                client: {
                  address: $address
                  state: $State
                  country: $Country
                  suburb: $suburb
                  postcode: $postcode
                  phone: $phone
                  fax: $fax
                  mobile: $mobile
                  title: $title
                  contact_name: $contactName
                  abn: $abn
                }
              ) {
                id
              }
            }
          `,
          variables: {
            address: address,
            State: state,
            Country: country,
            suburb: suburb,
            postcode: postcode,
            phone: phone,
            fax: fax,
            mobile: mobile,
            contactName: contact_name,
            title: title,
            abn: abn,
          },
        })
        .then(response => {
          // dispatch('getClients')
          return response.data.createClientRequest.id
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async acceptClientRequest({ commit, dispatch }, { id, approved } = {}) {
    try {
      // let that = this
      return await graphqlClient
        .mutate({
          mutation: gql`
            mutation AcceptClientRequest($id: ID!, $approved: Boolean) {
              acceptClientRequest(request_id: $id, accepted: $approved) {
                id
              }
            }
          `,
          variables: { id: id, approved: approved },
        })
        .then(response => {
          // dispatch('getClients')
          return response.data.createClientRequest.id
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
}
